import * as React from "react";
import { Navigate } from "react-router-dom";

const Page = () => {
  return (
    <>
      <Navigate to="/attendances" />
    </>
  );
};

export default Page;
